import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';
import { g as getRem, a as getPadding } from './styled-utils-3f8463ca.js';

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  text-decoration: none;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", "px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n  opacity: 0.4;\n  pointer-events: none;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    ", ";\n    ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    ", ";\n    ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    ", ";\n    ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  border: ", ";\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  border-radius: ", "px;\n  color: ", ";\n  cursor: pointer;\n  display: inline-flex;\n  text-align: center;\n  font-family: ", ";\n  line-height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var baseStyles = css(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.radii.sm;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.body;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.lineHeights.body;
});
var filledStyles = css(_templateObject2(), function (_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  return theme.colors[variant][5];
});
var outlineStyles = css(_templateObject3(), function (_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant;
  return theme.borders[variant];
}, function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant;
  return theme.colors[variant][5];
});
var sizeStyles = {
  sm: css(_templateObject4(), function (_ref8) {
    var theme = _ref8.theme;
    return getRem(theme.fontSizes.xs, theme.rootVal);
  }, function (_ref9) {
    var theme = _ref9.theme;
    return getPadding('py-1', theme);
  }, function (_ref10) {
    var theme = _ref10.theme;
    return getPadding('px-2', theme);
  }),
  md: css(_templateObject5(), function (_ref11) {
    var theme = _ref11.theme;
    return getRem(theme.fontSizes.sm, theme.rootVal);
  }, function (_ref12) {
    var theme = _ref12.theme;
    return getPadding('py-2', theme);
  }, function (_ref13) {
    var theme = _ref13.theme;
    return getPadding('px-3', theme);
  }),
  lg: css(_templateObject6(), function (_ref14) {
    var theme = _ref14.theme;
    return getRem(theme.fontSizes.base, theme.rootVal);
  }, function (_ref15) {
    var theme = _ref15.theme;
    return getPadding('py-3', theme);
  }, function (_ref16) {
    var theme = _ref16.theme;
    return getPadding('px-4', theme);
  })
};
var disabledStyles = css(_templateObject7());
var roundedStyles = css(_templateObject8(), function (_ref17) {
  var theme = _ref17.theme;
  return theme.radii.pill;
});
var StyledTag = styled.div(_templateObject9(), baseStyles, function (_ref18) {
  var isOutline = _ref18.isOutline;
  return isOutline ? outlineStyles : filledStyles;
}, function (_ref19) {
  var disabled = _ref19.disabled;
  return disabled && disabledStyles;
}, function (_ref20) {
  var size = _ref20.size;
  return sizeStyles[size];
}, function (_ref21) {
  var isRounded = _ref21.isRounded;
  return isRounded && roundedStyles;
});

var Button = function Button(_ref) {
  var children = _ref.children,
      type = _ref.type,
      variant = _ref.variant,
      size = _ref.size,
      href = _ref.href,
      isDisabled = _ref.isDisabled,
      isOutline = _ref.isOutline,
      isRounded = _ref.isRounded,
      handleClick = _ref.handleClick,
      className = _ref.className,
      id = _ref.id;
  var isButton = href === null;
  return React.createElement(StyledTag, {
    as: isButton ? 'button' : 'a',
    href: isButton ? null : href,
    variant: variant,
    id: id,
    size: size,
    type: type,
    onClick: handleClick,
    disabled: isDisabled,
    isOutline: isOutline,
    isRounded: isRounded,
    className: className
  }, children);
};

Button.defaultProps = {
  className: null,
  handleClick: null,
  href: null,
  id: null,
  isDisabled: false,
  isOutline: false,
  isRounded: false,
  size: 'md',
  type: 'button',
  variant: 'primary'
};
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "handleClick": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The function to be called when the Button is clicked"
    },
    "href": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The href for Button to point to. Renders an anchor tag"
    },
    "id": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The HTML id for the button"
    },
    "isDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not the Button is disabled"
    },
    "isOutline": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not the Button should be outlined"
    },
    "isRounded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not to render a rounded button"
    },
    "size": {
      "defaultValue": {
        "value": "'md'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'sm'",
          "computed": false
        }, {
          "value": "'md'",
          "computed": false
        }, {
          "value": "'lg'",
          "computed": false
        }]
      },
      "required": false,
      "description": "The size of Button to render"
    },
    "type": {
      "defaultValue": {
        "value": "'button'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'button'",
          "computed": false
        }, {
          "value": "'submit'",
          "computed": false
        }]
      },
      "required": false,
      "description": "The HTML type attribute for the button"
    },
    "variant": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }]
      },
      "required": false,
      "description": "The color variant of the Button"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "Content of the Button"
    }
  }
};
export default Button;
export { Button };